import { render } from "./KutipanSemasaDaerah.vue?vue&type=template&id=ef288d4c"
import script from "./KutipanSemasaDaerah.vue?vue&type=script&lang=js"
export * from "./KutipanSemasaDaerah.vue?vue&type=script&lang=js"

import "./KutipanSemasaDaerah.vue?vue&type=style&index=0&id=ef288d4c&lang=css"
import "./KutipanSemasaDaerah.vue?vue&type=style&index=1&id=ef288d4c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__